
// Fancybox Config
$('[data-fancybox]').fancybox({
    animationEffect: "slide",
    transitionEffect: "circular",
    loop: true,
    buttons : [ 
      'zoom',
      'download',
      'share',
      'slideShow',
      'fullScreen',
      'thumbs',
      'close'
    ]
});
